module.exports = __webpack_public_path__ + "zip/showtime8x11.zip";